// extracted by mini-css-extract-plugin
export var borderRadius = "_9w-4";
export var large = "_9w-3";
export var logoContainer = "_9w-0";
export var nameLogo = "_9w-2";
export var small = "_9w-1";